<template>
  <div
    class="order-card"
    :style="{ backgroundColor: coldColor }"
  >
    <div class="d-flex justify-content-between align-items-start">
      <div class="d-flex flex-column">
        <span class="h4 font-weight-bold">#{{ order.id.toString().slice(-3) }} - {{ order.customer && getFirstName(order.customer.name) }}</span>
      </div>
      <span class="badge badge-cold">{{ coldLabel }}</span>
    </div>
    <div class="d-flex justify-content-end">
      <span
        v-if="waitingTime !== null"
        class="small"
      >Tempo de espera: {{ waitingTime }} min</span>
    </div>
    <ul class="mb-1">
      <li
        v-for="item in order.items"
        :key="item.id"
      >
        <span class="font-weight-bold">{{ item.quantity }}x</span> -
        <span class="font-weight-bold">{{ item.sku && item.sku.name }}</span> -
        <span>{{ item.netValue | currency }}</span>
      </li>
    </ul>
    <div class="d-flex justify-content-end mb-0">
      <span class="font-weight-bold">Total: {{ order.netValue | currency }}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="order-card-footer mt-1">
        <b-button
          v-if="order.preparationStatus === 'Pending'"
          variant="primary"
          size="lg"
          block
          class="font-weight-bold"
          @click="onPrintPrepare"
        >
          Iniciar Preparo
        </b-button>
        <b-button
          v-if="order.preparationStatus === 'Preparing'"
          variant="primary"
          size="lg"
          block
          class="font-weight-bold"
          @click="onMarkReady"
        >
          Finalizar Preparo
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'PreparationOrderCard',
  components: { BButton },
  filters: {
    currency(val) {
      if (typeof val !== 'number') return val
      return val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
  },
  props: {
    order: { type: Object, required: true },
    printOnPrepare: { type: Boolean, default: true },
  },
  computed: {
    coldLabel() {
      switch (this.order.coldOption) {
        case 'Cold': return 'Gelada'
        case 'ColdOnIce': return 'Embalada no gelo'
        default: return 'Natural'
      }
    },
    coldColor() {
      switch (this.order.coldOption) {
        case 'ColdOnIce': return '#64B5F6' // lilás claro
        case 'Cold': return '#C8E6C9' // azul claro
        default: return '#CFD8DC' // amarelo claro
      }
    },
    waitingTime() {
        // Precisa de issueDate (criação) e preparationStatusDate (quando ficou pronto)
        // Se status é Pending ou Preparing: diferença issueDate -> agora
        // Se status é Done: diferença issueDate -> preparationStatusDate
        if (!this.order.issueDate) return null
        const issueDate = new Date(this.order.issueDate)
        let endDate = null
        if (this.order.preparationStatus === 'Done' && this.order.preparationStatusDate) {
            endDate = new Date(this.order.preparationStatusDate)
        } else if (this.order.preparationStatus === 'Pending' || this.order.preparationStatus === 'Preparing') {
            endDate = new Date()
        } else {
            return null
        }
        const diffMs = endDate - issueDate
        if (Number.isNaN(diffMs)) return null
        const diffMin = Math.floor(diffMs / 60000)
        return diffMin
    },
  },
  methods: {
    onPrintPrepare() {
      this.$emit('update-status', { saleId: this.order.id, newStatus: 'Preparing', print: this.printOnPrepare })
    },
    onMarkReady() {
      this.$emit('update-status', { saleId: this.order.id, newStatus: 'Done' })
    },
    getFirstName(name) {
      if (!name) return ''
      return name.split(' ')[0]
    },
  },
}
</script>

<style scoped>
.order-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  padding: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 220px;
}
.order-card-footer {
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.badge-cold {
  font-size: 0.9em;
  padding: 0.2em 0.7em;
  background: #333;
  color: #fff;
  border-radius: 12px;
}
</style>